import { Link as GatsbyLink } from 'gatsby'
import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Stack } from '../../shared/stack/Stack'
import { Typography } from '../../shared/typography/typography'
import { HeaderBrandLogo } from './header-brand-logo'

export type HeaderBrandProps = {
  title: string
}

export const HeaderBrand = forwardRef(function HeaderBrand(
  { title, ...props },
  ref,
) {
  return (
    <GatsbyLink
      to="/"
      className="hover:scale-[1.05] transition-transform duration-200"
    >
      <Stack align="center" justify="space-between" {...props} ref={ref}>
        <Stack align="center" gap={16}>
          <HeaderBrandLogo />
          <Typography scale="overline" emphasis="strong">
            {title}
          </Typography>
        </Stack>
      </Stack>
    </GatsbyLink>
  )
}) as Polymorphic<'div', HeaderBrandProps>
